import { DefaultApiGetWritebacksRequest } from "@coeff/api-admin-ext";
import React from "react";

import { FlexRow, Tag } from "../../../components";
import { ExportCSVButton } from "../../WorkspaceAdmin/ExportCSVButton";
import { TabName } from "../../WorkspaceAdmin/WorkspaceAdmin";
import { TableFilters } from "../useTableFilters";

import { DebouncedSearchInput } from "./DebouncedSearchInput";
import {
  DataSourceFilterPopover,
  RunStatusFilterPopover,
  TriggerFilterPopover,
  UserFilterPopover,
} from "./FilterPopovers";

type Props = {
  domain: string;
  initialSearch: string;
  onSearchChange: (search: string) => void;
  filters: TableFilters<keyof DefaultApiGetWritebacksRequest>;
  setFilters: (filters: TableFilters<keyof DefaultApiGetWritebacksRequest>) => void;
};

export const WritebacksFilterToolbar: React.FC<Props> = ({
  domain,
  onSearchChange,
  initialSearch,
  filters,
  setFilters,
}) => {
  const dataSourceId = filters.data_source_id?.[0];

  return (
    <FlexRow style={{ justifyContent: "space-between" }}>
      <FlexRow style={{ flex: 1 }}>
        <DebouncedSearchInput initialSearch={initialSearch} onChange={onSearchChange} />

        {dataSourceId ? (
          <Tag
            closable
            onClose={() =>
              setFilters({
                ...filters,
                data_source_id: undefined,
              })
            }
          >
            <b>Source:</b> {dataSourceId}
          </Tag>
        ) : null}
      </FlexRow>

      <FlexRow>
        <DataSourceFilterPopover
          domain={domain}
          table="writebacks"
          entityLabel="Destination"
          values={filters.data_source_type}
          onChange={values =>
            setFilters({
              ...filters,
              data_source_type: values,
            })
          }
        />

        <RunStatusFilterPopover
          values={filters.status}
          onChange={values =>
            setFilters({
              ...filters,
              status: values,
            })
          }
        />

        <TriggerFilterPopover
          values={filters.trigger}
          onChange={values =>
            setFilters({
              ...filters,
              trigger: values,
            })
          }
        />

        <UserFilterPopover
          domain={domain}
          table="writebacks"
          values={filters.user_id}
          onChange={values =>
            setFilters({
              ...filters,
              user_id: values,
            })
          }
        />

        <ExportCSVButton tab={TabName.writebacks} />
      </FlexRow>
    </FlexRow>
  );
};
